import React from "react";
import { SmartLink } from "./SmartLink";

const urlRegex = /https?:\/\/[^\s)]+/gi;

export function LinkifiedText({ text }: { text: string }) {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  const matches = text.matchAll(urlRegex);

  for (const match of matches) {
    const start = match.index ?? 0;
    const url = match[0];

    if (start > lastIndex) parts.push(text.slice(lastIndex, start));

    parts.push(
      <SmartLink key={start + url} href={url} className="underline hover:no-underline break-words">
        {url}
      </SmartLink>
    );

    lastIndex = start + url.length;
  }

  if (lastIndex < text.length) parts.push(text.slice(lastIndex));

  return <>{parts}</>;
}
